import { render, staticRenderFns } from "./CargoHierarchy.vue?vue&type=template&id=4f1468ea&scoped=true"
import script from "./CargoHierarchy.vue?vue&type=script&lang=js"
export * from "./CargoHierarchy.vue?vue&type=script&lang=js"
import style0 from "./CargoHierarchy.vue?vue&type=style&index=0&id=4f1468ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1468ea",
  null
  
)

export default component.exports